var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{staticClass:"my-3",attrs:{"src":require('../assets/logo.jpg'),"contain":"","height":"200"}})],1),_c('v-col',[_c('login')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }